// extracted by mini-css-extract-plugin
export default {"input":"ApplicabilityModal_input__C54EU"};